<script setup lang="ts">
import { computed } from 'vue';

const RADIUS = 70;

interface Props {
  progress: number;
  size: number;
  stroke: number;
}

const props = defineProps<Props>();

const sizeWithPx = computed((): string => `${props.size}px`);

const dasharray = 2 * Math.PI * RADIUS;

const dashoffset = computed((): number => dasharray * ((100 - props.progress) / 100));
</script>

<template>
  <svg class="ui-progress-circle" viewBox="0 0 160 160" style="transform: rotate(-90deg)">
    <circle
      :r="RADIUS"
      cx="80"
      cy="80"
      fill="transparent"
      :stroke-width="`${props.stroke}px`"
    ></circle>
    <circle
      :r="RADIUS"
      cx="80"
      cy="80"
      fill="transparent"
      stroke-linecap="round"
      :stroke-width="`${props.stroke}px`"
      :stroke-dasharray="dasharray"
      :stroke-dashoffset="dashoffset"
    ></circle>
  </svg>
</template>

<style scoped>
.ui-progress-circle {
  width: v-bind(sizeWithPx);
  height: v-bind(sizeWithPx);
}

.ui-progress-circle circle {
  stroke: var(--color-purple);
}

.ui-progress-circle circle:first-child {
  opacity: 0.2;
}
</style>
